<template>
  <section>
    <div class="status">
      <h2 v-translate>Přiřazené domény</h2> <h2>&nbsp;({{ totalCount }})</h2>
      <a
          v-if="$_loggedUser_action_allowed('brandDomains', 'create')"
          :title="'Přidat doménu' | translate"
          :class="['add', 'add_expand', { open: newDomainOpen }]"
          @click.prevent="toggleNewDomain()"
          v-translate>Přidat Doménu
      </a>
    </div>
    <div :class="['filter', 'expand_content', { open: newDomainOpen }]">
      <div class="field_left">
        <text-input
            id="domain-domain-add-1"
            v-model="newDomain.domain"
            :required="true"
            ref="newdomaindomain"
        >
          <translate class="translate">Doména</translate>
        </text-input>
      </div>
      <div class="field_right">
        <text-input-with-submit
            id="domain-css-code-add"
            v-model="newDomain.css_code"
            ref="newdomaincsscode"
            @submit="emitAddNewDomain"
        >
          <translate class="translate">CSS Kód</translate>
        </text-input-with-submit>
      </div>
    </div>

    <table class="vypis vypis_detail">
      <thead>
      <tr>
        <th class="no_padding drag_drop"></th>
        <th class="no_padding checkbox"/>
        <sorting-table-title
            v-for="title in domainTableTitles"
            :key="title.key"
            :column="title.column"
            :sort="getActiveSort(title.column)"
            @changeSorting="changeSorting"
        >{{ title.name }}</sorting-table-title>
        <th class="no_padding edit"></th>
      </tr>
      </thead>
      <domain-row
          v-for="entity in entities"
          :entity="entity"
          :key="entity.id"
          @deleteDomain="deleteDomain"
          @updateDomain="updateDomain"
          :selectedEntities="selectedEntities"
          :ref="'domain-row-ref-'+entity.id"
          @opened="domainRowOpened"
      ></domain-row>
      <tr v-if="!entities || entities.length === 0">
        <td :colspan="domainTableTitles.length + 2">{{ $gettext('Nebyly přiřazeny žádné domény.') }}</td>
      </tr>
    </table>

    <list-action-line
        :entities="entities"
        :offset="formFields.offset"
        :limit="formFields.limit"
        :total-count="totalCount"
        @limit="setLimit"
        @offset="setOffset"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        @select-all="toggleSelectAll"
        @run-multiple-action="runMultipleAction"
        ref="action_line"
    ></list-action-line>
  </section>
</template>

<script>
import requiredFields from "@/components/mixins/required-fields"
import SortingTableTitle from "../../../common/SortingTableTitle";
import listActions from "@/components/mixins/list-actions"
import TextInputWithSubmit from "../../subscribers/devices/TextInputWithSubmit";
import DomainRow from "./DomainRow";

export default {
  name: "DomainList",
  components: {
    DomainRow,
    TextInputWithSubmit,
    SortingTableTitle,
  },
  mixins: [requiredFields, listActions],
  created(BrandDomainService) {
    this.entityService = BrandDomainService
    this.createdInit()
  },
  data() {
    return {
      moduleName: 'domains',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      },
      requiredDomainRefs: [
        'newdomaindomain',
        'newdomaincsscode',
      ],
      newDomainOpen: false,
      newDomain: {
        id_brand: this.entity.id,
        domain: null,
        css_code: null,
      }
    }
  },
  props: {
    entity: Object,
    errorMessages: {
      type: [Array, Object],
      default: function () {
        return []
      },
    },
  },
  computed: {
    domainTableTitles() {
      return [
        {key: 1, name: this.$gettext('Doména'), column: 'sDomain'},
        {key: 2, name: this.$gettext('CSS kód'), column: 'sCssCode'},
        {key: 5, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 6, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.domainTableTitles);
    },
  },
  methods: {
    reactivateComponent() {
      this.getEntities();
    },
    getEntities() {
      let getEntitiesParams = {
        ...this._processFormFields(this.getFormFields()),
        id_brand: this.entity.id
      };

      this.setLoadingMessage()
      this._processGetEntitiesResponse(this.entityService.getEntities(getEntitiesParams))
    },
    _exportCsv(){
      let getEntitiesParams = {
        ...this._processFormFields(this.getFormFields()),
        id_brand: this.entity.id
      };
      delete getEntitiesParams.limit;
      delete getEntitiesParams.offset;
      this.setLoadingMessage()
      this._processGetEntitiesCsvResponse(this.entityService.getEntities(getEntitiesParams), this.csvHeaders)
    },
    resetNewDomain() {
      this.resetNewDomainDomain()
      this.resetNewDomainCssCode()

      this.newDomain.domain = null;
      this.newDomain.css_code = null;
    },
    resetNewDomainDomain() {
      this.$refs['newdomaindomain'].setForcedInvalid()
      this.$refs['newdomaindomain'].setTouched(false)
    },
    resetNewDomainCssCode() {
      this.$refs['newdomaincsscode'].setForcedInvalid()
      this.$refs['newdomaincsscode'].setTouched(false)
    },
    toggleNewDomain() {
      this.newDomainOpen = !this.newDomainOpen;

      if (!this.newDomainOpen) {
        this.resetNewDomain();
      }
    },
    emitAddNewDomain() {
      this.createDomain({...this.newDomain});
    },
    createDomain(domainData) {
      this.resetNewDomainDomain();

      if (!domainData.domain || domainData.length < 2) {
        this.$refs["newdomaindomain"].setForcedInvalid(true, "Doména musí být vyplněna");
      } else {
        return this.entityService.createEntity(domainData).then(() => {
          this.reactivateComponent();
          this.toggleNewDomain();
        }).catch(this._checkAddErrors);
      }
    },
    _checkAddErrors(error) {
      let errorMessage = error['error_message'];

      this._.forEach(error['validation_errors'], function (message) {
        if (message.match("^Domain \"(.+)\" is not unique\.$")) {
          errorMessage = this.$gettext("Tato doména již existuje.");

          if (this.newDomainOpen) {
            this.$refs["newdomaindomain"].setForcedInvalid(true, "Doména již existuje");
          }
        } else if (message.match("^Domain \"(.+)\" is not available\.$")) {
          errorMessage = this.$gettext("Tuto doménu nelze použít.");

          if (this.newDomainOpen) {
            this.$refs["newdomaindomain"].setForcedInvalid(true, "Neplatná doména");
          }
        }
      }.bind(this))

      this.setErrorMessage(errorMessage);

      return errorMessage;
    },
    deleteDomain(idDomain) {
      this.$emit("delete-domain", idDomain);
    },
    updateDomain(domainData, domainRow) {
      this.entityService.updateEntity(domainData.id, {
          domain: domainData.domain,
          css_code: domainData.css_code
      }).then(() => {
        domainRow.closeMoreInfo();
        this.reactivateComponent();
      }).catch((error) => {
        let errorMessage = this._checkAddErrors(error);
        domainRow.$refs["domainref"].setForcedInvalid(true, errorMessage)
      });
    },
    domainRowOpened(idDomain) {
      this.entities.forEach((entity) => {
        if (entity.id !== idDomain) {
          let rowRef = 'domain-row-ref-' + entity.id;

          if (this.$refs[rowRef]) {
            this.$refs[rowRef][0].closeMoreInfo();
          }
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/brands/forms/DomainList.vue